// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"131":"25fae8fa548e9e5a","706":"1fb1fc6c41476dab","859":"4f930916b284eede"}[chunkId] + ".js";
};